import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Link, SectionHeader } from 'web-library';
import { Typography } from '@mui/material';
import ReceiptDetails from '../../../components/ReceiptDetails';
import { ResitSimplePaymentDetail } from '../../../models/@candidate/candidateResitRegistrationSchema';

export interface TransactionDetailProps {
  hideTitle?: boolean;
  transaction: ResitSimplePaymentDetail | undefined;
  toSummary?: () => void;
}

const TransactionDetail = ({
  hideTitle = false,
  transaction,
  toSummary = () => {
    // do nothing
  },
}: TransactionDetailProps) => {
  const { t } = useTranslation();
  return (
    <>
      {!hideTitle && (
        <Grid container>
          <Grid xs={12}>
            <SectionHeader
              title={t('resit->>ResitReceipt.Payment Summary')}
            >
              <Link id="link-viewFullSummary" onClick={toSummary}>
                <Typography variant="h5">
                  {t('resit->>ResitReceipt.View full summary')}
                </Typography>
              </Link>
            </SectionHeader>
          </Grid>
        </Grid>
      )}
      <ReceiptDetails transaction={transaction} />
    </>
  );
};

export default TransactionDetail;
